import type { Translator } from '@porotutu/i18n'

export const STOP_SCOPES = {
  forbidden: 'pages.forbidden',
  not_found: 'pages.not_found',
  unavailable: 'pages.unavailable',
} as const

export type Stop = keyof typeof STOP_SCOPES

export const statusOf = (error: unknown): number | undefined =>
  typeof error === 'object' &&
  error !== null &&
  'status' in error &&
  typeof error.status === 'number'
    ? error.status
    : undefined

export const stopFor = (status: number | undefined): Stop =>
  status === 403 ? 'forbidden' : status === 404 ? 'not_found' : 'unavailable'

export const messageOf = (t: Translator, status: number | undefined): string =>
  status === 429 ? t('errors.rate_limited') : t(`${STOP_SCOPES[stopFor(status)]}.heading`)
